<template>
  <div class="sidebar-page-wrapper">
    <div
      class="sidebar-menu-bg"
      v-if="menuBg && $root.screenWidth > 550"
      :style="{ 'background-image': `url(${menuBg})` }"
    ></div>
    <div
      class="sidebar"
      :style="{
        'background-image': $root.screenWidth <= 550 ? `url(${menuBg})` : ''
      }"
    >
      <el-menu
        router
        :default-active="$route.path"
        class="sidebar-menu"
        :mode="$root.screenWidth > 550 ? 'vertical' : 'horizontal'"
      >
        <el-menu-item index="/patients/monitor" v-if="p('Patients.View')">
          <span slot="title">{{
            $t('text.patient', {
              patient: $store.state.locale.patient
            }).toUpperCase()
          }}</span>
        </el-menu-item>
        <el-submenu
          index="/patients/voiding-chart"
          v-if="
            p('Patients.Charts.Void.View') ||
              p('Patients.Charts.FillProfile.View') ||
              p('Patients.Charts.BodyPosition.View') ||
              p('Patients.Charts.Event.View') ||
              p('Patients.Charts.Observation.View') ||
              p('Patients.Charts.PhysicalActivity.View')
          "
        >
          <template slot="title">
            <span>{{ $t('text.charts').toUpperCase() }}</span>
          </template>
          <el-menu-item
            index="/patients/voiding-chart"
            v-if="p('Patients.Charts.Void.View')"
            >{{ $t('text.void_chart') }}</el-menu-item
          >
          <el-menu-item
            index="/patients/smartz-events-chart"
            v-if="p('Patients.Charts.Event.View')"
            v-html="$t('text.events')"
          ></el-menu-item>
          <el-menu-item
            index="/patients/pad-fill-profile-chart"
            v-if="p('Patients.Charts.FillProfile.View')"
            >{{
              $t('text.pad_fill_profile', {
                pad: $firstLetterCapitalize($store.state.locale.pad)
              })
            }}</el-menu-item
          >
          <el-menu-item
            index="/patients/position-chart"
            v-if="p('Patients.Charts.BodyPosition.View')"
            >{{ $t('text.body_position') }}</el-menu-item
          >
          <el-menu-item
            index="/patients/observation-chart"
            v-if="p('Patients.Charts.Observation.View')"
            >{{ $t('text.observation_chart') }}</el-menu-item
          >
          <el-menu-item
            index="/patients/physical-activity-chart"
            v-if="p('Patients.Charts.PhysicalActivity.View')"
            >{{ $t('text.physical_activity_chart') }}</el-menu-item
          >
          <!-- <el-menu-item index="/patients/smartz-devices">{{
            $t('text.smartz_devices')
          }}</el-menu-item> -->
        </el-submenu>
        <el-submenu
          index="/patients/pad-fill-profile-goal"
          v-if="
            p('Patients.Goals.FillProfile.View') ||
              p('Patients.Goals.SkinCare.View') ||
              p('Patients.Goals.Position.View') ||
              p('Patients.Goals.Temperature.View') ||
              p('Patients.Goals.Fall.View')
          "
        >
          <template slot="title">
            <span>{{ $t('text.goal').toUpperCase() }}</span>
          </template>
          <el-menu-item
            index="/patients/position-goal"
            :class="{
              'goal-active':
                goal.IsDayPosGoalEnabled || goal.IsNightPosGoalEnabled
            }"
            v-if="p('Patients.Goals.Position.View')"
            >{{
              this.$store.state.locale.currentLocale === 'de'
                ? $t('text.body_position_goal_for_de')
                : $t('text.body_repositioning')
            }}</el-menu-item
          >
          <el-menu-item
            index="/patients/productivity-goal"
            :class="{
              'goal-active':
                goal.IsMaxDayDiaperGoalEnabled ||
                goal.IsMaxNightDiaperGoalEnabled
            }"
            v-if="p('Patients.Goals.SkinCare.View')"
            >{{ $t('text.productivity') }}</el-menu-item
          >
          <el-menu-item
            index="/patients/skin-care-goal"
            :class="{
              'goal-active':
                goal.IsDayPadGoalEnabled ||
                goal.IsNightPadGoalEnabled ||
                goal.IsDayMaxYellowGoalEnabled ||
                goal.IsNightMaxYellowGoalEnabled
            }"
            v-if="p('Patients.Goals.SkinCare.View')"
            >{{ $t('text.skin_care') }}</el-menu-item
          >
          <el-menu-item
            index="/patients/pad-fill-profile-goal"
            :class="{
              'goal-active':
                goal.IsDayGoalVolEnabled || goal.IsNightGoalVolEnabled
            }"
            v-if="p('Patients.Goals.FillProfile.View')"
            >{{
              $t('text.pad_fill_profile', {
                pad: $firstLetterCapitalize($store.state.locale.pad)
              })
            }}</el-menu-item
          >
          <el-menu-item
            index="/patients/temperature-goal"
            :class="{ 'goal-active': goal.IsTempGoalEnabled }"
            v-if="p('Patients.Goals.Temperature.View')"
            >{{ $t('text.temperature') }}</el-menu-item
          >
          <el-menu-item
            index="/patients/fall-detection-goal"
            :class="{ 'goal-active': goal.IsFallGoalEnabled }"
            v-if="p('Patients.Goals.Fall.View')"
            >{{ $t('text.falls') }}</el-menu-item
          >
        </el-submenu>
        <el-menu-item
          index="/patients/inco-assessment"
          v-if="p('Patients.Inco-assessment.View')"
        >
          <span slot="title">{{
            $t('text.inco_assessment').toUpperCase()
          }}</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="sidebar-type-page-content">
      <PatientFilter v-if="$route.path !== '/patients/landing'" />
      <Helper v-if="$route.path !== '/patients/landing'" />
      <router-view ref="content" />
    </div>
  </div>
</template>

<script>
import Helper from '@/components/Helper.vue'
import PatientFilter from '@/components/dashboard/PatientFilter.vue'
export default {
  components: {
    Helper,
    PatientFilter
  },
  computed: {
    menuBg() {
      return this.$store.state.customization.menuBg
    },
    goal() {
      return this.$store.state.patient.selectedPatientGoal
    }
  },
  mounted() {
    this.$store.dispatch('patient/getSelectedPatientGoal')
    this.$store.dispatch('patient/getSelectedPatientHistoryData')
  },
  watch: {
    '$store.state.patient.selectedPatient.patientId'() {
      this.$store.dispatch('patient/getSelectedPatientGoal')
      this.$store.dispatch('patient/getSelectedPatientHistoryData')
    }
  }
}
</script>
